const PREFIX = 'INE-IN-';
export const PREFIX_INTERNET = 'INE-INT-';
export const PREFIX_VIA_PUBLICA = 'INE-VP-';
/**
 * Devuelve el valor numérico del Folio de acuerdo a una función que quita el prefijo del mismo.
 * @param {String} folio - El folio a limpiar.
 * @param {String} prefixToRemove - El prefijo a quitar, en caso de no incluirse se tomará el prefijo default.
 * @returns {Number} Valor numérico del folio.
 */
export const getFolioNumber = (folio, prefixToRemove) => {
  if (!folio) return null;
  try {
    const prefixToUse = prefixToRemove || PREFIX;
    return Number(folio.slice(prefixToUse.length));
  } catch (error) {
    return null;
  }
};
